// Extended Angular Firestore


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/observable/of';
import { switchMap, take } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';
export class ExtendedAngularFirestore {
/**
 * @param {?} afs
 */
constructor(private afs: AngularFirestore) {}
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
documentExists<T>(ref: string): Promise<boolean> {
        return this.documentExistsObs<T>(ref).toPromise();
    }
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
private documentExistsObs<T>(ref: string): Observable<boolean> {
        return this.afs.doc<T>(ref).snapshotChanges()
                   .map(snap => snap.payload.exists);
    }
/**
 * @template T
 * @param {?} ref
 * @param {?} document
 * @return {?}
 */
createNewDocument<T>(ref: string, document: T): Promise<void> {
        return this.afs.doc<T>(ref).set(document);
    }
/**
 * @template T
 * @param {?} ref
 * @param {?} document
 * @return {?}
 */
updateExistingDocument<T>(ref: string, document: T): Promise<void> {
        return this.afs.doc<T>(ref).update(document);
    }
/**
 * @template T
 * @param {?} ref
 * @param {?} document
 * @return {?}
 */
upsert<T>(ref: string, document: T): Promise<void> {
        return this.documentExistsObs<T>(ref)
                   .pipe(switchMap (exists => {
                       if (exists) { return this.updateExistingDocument<T>(ref, document); } else {
                         return this.createNewDocument<T>(ref, document);
                        }
                   })).toPromise();
    }
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
deleteDocument<T>(ref: string): Promise<void> {
        return this.afs.doc<T>(ref).delete();
    }
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
downloadDocument<T>(ref: string): Promise<T> {
        return this.documentExistsObs<T>(ref)
                   .pipe( switchMap(exists => {
                        if (exists) {
                            return this.afs.doc<T>(ref).valueChanges().pipe(take(1));
                        } else {
                            return Observable.of<T>(null);
                        }
                   })).toPromise<T>();
    }
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
listenForChangesToDocument<T>(ref: string): Observable<T> {
        return this.afs.doc<T>(ref).valueChanges();
    }
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
downloadCollection<T>(ref: string): Promise<Array<T>> {
        return this.afs.collection<T>(ref).valueChanges()
                                          .pipe(take(1)).toPromise();
    }
/**
 * @template T
 * @param {?} ref
 * @return {?}
 */
listenForChangesToCollection<T>(ref: string): Observable<Array<T>> {
        return this.afs.collection<T>(ref).valueChanges();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AngularFirestore, },
];
}

function ExtendedAngularFirestore_tsickle_Closure_declarations() {
/** @type {?} */
ExtendedAngularFirestore.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ExtendedAngularFirestore.ctorParameters;
/** @type {?} */
ExtendedAngularFirestore.prototype.afs;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
